import type React from "react";

import { ParagraphLarge, ParagraphMedium } from "styles/elements/Texts";
import { CssFlex, CssIcon } from "styles/helpers/layout";
import { type FeedbackMessageVariant, StyledFeedbackMessage } from "./FeedbackMessage.styled";

interface FeedbackMessageProps {
  dataCy?: string;
  className?: string;
  title: string;
  description?: React.ReactNode;
  variant?: FeedbackMessageVariant;
  hideIcon?: boolean;
}

export const FeedbackMessage: React.FC<FeedbackMessageProps> = ({
  dataCy,
  className,
  title,
  description,
  variant = "info",
  hideIcon = false,
}) => {
  const iconPerVariant: Record<FeedbackMessageVariant, string> = {
    info: "fas fa-info-circle",
    error: "fas fa-exclamation-circle",
    success: "fas fa-check-circle",
    warning: "fas fa-exclamation-triangle",
  };

  return (
    <StyledFeedbackMessage
      className={className}
      data-cy={dataCy}
      $variant={variant}
      flexDirection="row"
      gap={1}
    >
      {!hideIcon && <CssIcon iconName={iconPerVariant[variant]} />}
      <CssFlex flexDirection="column" gap={1}>
        <ParagraphLarge>{title}</ParagraphLarge>
        {description && <ParagraphMedium>{description}</ParagraphMedium>}
      </CssFlex>
    </StyledFeedbackMessage>
  );
};
